import * as React from 'react';
import styles from "./segmentInfo.module.scss";
import { Grid, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

const SegmentInfo = ({ showSummary, summary }) => {
    const location = useLocation()
    return (
        <Grid container item xs={4} className={styles.text} marginTop="10px" >
            {showSummary && <Typography className={styles.heading}>{summary.segmentName || summary.name}</Typography>}
            {!showSummary && location.pathname === "/createSegment" && <Typography className={styles.heading}>Create Customer segment</Typography>}
            {!showSummary && location.pathname === "/viewSegments" && <Typography className={styles.heading}>Customer segments</Typography>}
        </Grid>
    );
}
export default SegmentInfo